// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lp-admin-earnings .lp-earn-hero {
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 45%, #0f172a 100%);
  color: #f8fafc;
  margin-bottom: 1.25rem;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.2);
}

.lp-admin-earnings .lp-earn-stat {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 1rem 1.1rem;
  height: 100%;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.lp-admin-earnings .lp-earn-stat:hover {
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.lp-admin-earnings .lp-earn-stat .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
}

.lp-admin-earnings .lp-earn-stat .value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.lp-admin-earnings .lp-earn-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  overflow: hidden;
}

.lp-admin-earnings .lp-earn-card .card-header-lp {
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  font-weight: 600;
  color: #0f172a;
}

.lp-admin-earnings .lp-earn-chart-wrap {
  position: relative;
  height: 320px;
  padding: 0.5rem 1rem 1rem;
}

.lp-admin-earnings .table thead th {
  border-top: none;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}

.lp-admin-earnings .lp-user-link {
  font-weight: 600;
  color: #2563eb;
}

.lp-admin-earnings .lp-user-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.lp-admin-earnings .lp-top-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  background: #fafafa;
}

.lp-admin-earnings .lp-top-user .rank {
  font-weight: 700;
  color: #94a3b8;
  min-width: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/Earings.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,cAAc;EACd,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,0DAA0D;EAC1D,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".lp-admin-earnings .lp-earn-hero {\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 45%, #0f172a 100%);\n  color: #f8fafc;\n  margin-bottom: 1.25rem;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.2);\n}\n\n.lp-admin-earnings .lp-earn-stat {\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 1rem 1.1rem;\n  height: 100%;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.lp-admin-earnings .lp-earn-stat:hover {\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.lp-admin-earnings .lp-earn-stat .label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.lp-admin-earnings .lp-earn-stat .value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.lp-admin-earnings .lp-earn-card {\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  overflow: hidden;\n}\n\n.lp-admin-earnings .lp-earn-card .card-header-lp {\n  padding: 0.85rem 1.25rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.lp-admin-earnings .lp-earn-chart-wrap {\n  position: relative;\n  height: 320px;\n  padding: 0.5rem 1rem 1rem;\n}\n\n.lp-admin-earnings .table thead th {\n  border-top: none;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n}\n\n.lp-admin-earnings .lp-user-link {\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.lp-admin-earnings .lp-user-link:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n.lp-admin-earnings .lp-top-user {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.65rem 0.85rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  margin-bottom: 0.5rem;\n  background: #fafafa;\n}\n\n.lp-admin-earnings .lp-top-user .rank {\n  font-weight: 700;\n  color: #94a3b8;\n  min-width: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
